var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2557 8.6789H30.4542L23.07 4L16 8.6789H17.0414M29.2557 8.6789V15.5M29.2557 8.6789H17.0414M17.0414 8.6789V11",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H13.2414C7.58522 5 3 9.92487 3 16M13.6207 8.66667H13.2414C9.47061 8.66667 6.41379 11.9499 6.41379 16M13.6207 11.9259H13.2414C11.1465 11.9259 9.44828 13.75 9.44828 16",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5805 13.7891V22.0569H32.52V28.3793H11.7014V13.7891H25.5805Z",
    fill: "#FC9C9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5505 17.8203H25.7473V22.07H31.7119L29.5505 17.8203Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1596 22.3288L29.5505 17.8203H25.7473V24.6123",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0397,
    cy: 29.8794,
    r: 2.02,
    fill: "white",
    stroke: "#383434"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8405,
    cy: 29.8794,
    r: 2.02,
    fill: "white",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodOnlineIcon);
export default __webpack_public_path__ + "static/media/codOnlineIcon.b3015c14cca69dc9f97b385b3cddfec6.svg";
export { ForwardRef as ReactComponent };